import React from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { WatchedPageMessagesBlock } from '../../_blocks/WatchedPageMessages/WatchedPageMessagesBlock';
import { Namespace } from '../../translation/namespace';
import { Icons } from '../../components/atoms/SVG';

export type WatchedPageMessagesWidget = WidgetShape<[WatchedPageMessagesBlock], WidgetType.watchedpagemessagesblock>;

export function WatchedPageMessagesWidget({ blocks, elementType, ...headerProps }: WatchedPageMessagesWidget) {
  const { t } = useTranslation(Namespace.WatchedPageMessagesPanel);

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      hierarchy={3}
      title={t('widgetTitle')}
      icon={Icons.OBSERVE_EYE}
    >
      <WatchedPageMessagesBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
